import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const CostOperation = styled(Typography)``

export default CostOperation
